import Konva from "konva";
import { Button, ButtonGroup, DropdownButton, Icon } from "./toolbar-buttons";
import toolbar_styles from "./elements-toolbar.module.css";
import { AlignmentFns, AlignmentTypes, distributeH, distributeV } from "frontend/utils/alignment-utils";
import cn from "classnames";

export function AlignmentButton({
  nodes,
  setNodePosition,
  onMutationEnd,
}: {
  nodes: Konva.Node[];
  setNodePosition: (id: string, pos: { x: number; y: number }) => void;
  onMutationEnd: (e: any) => void;
}) {
  function onAlign(evt: any) {
    const align = (evt.currentTarget as HTMLButtonElement).dataset.align;
    if (align && align in AlignmentFns) {
      const movementData = AlignmentFns[align as AlignmentTypes](nodes);
      for (const move of movementData) {
        move.node.fire("transformstart"); // save props for undo
        setNodePosition(move.node.id(), move.target);
      }
      // HACK: I can only record the mutation after the elements moved, which does not
      // happen in this frame.
      // we really should have a way of scheduling an action for next subscription (updated elements)
      setTimeout(onMutationEnd, 50); // record the operation in the undo stack
    } else {
      console.error("alignment button isn't configured correctly");
    }
  }

  function onDistributeH() {
    const moveData = distributeH(nodes);
    for (const move of moveData) {
      move.node.fire("transformstart");
      setNodePosition(move.node.id(), move.target);
    }
    // HACK: I can only record the mutation after the elements moved, which does not
    // happen in this frame.
    // we really should have a way of scheduling an action for next subscription (updated elements)
    setTimeout(onMutationEnd, 50); // record the operation in the undo stack
  }

  function onDistributeV() {
    const moveData = distributeV(nodes);
    for (const move of moveData) {
      move.node.fire("transformstart");
      setNodePosition(move.node.id(), move.target);
    }
    // HACK: I can only record the mutation after the elements moved, which does not
    // happen in this frame.
    // we really should have a way of scheduling an action for next subscription (updated elements)
    setTimeout(onMutationEnd, 50); // record the operation in the undo stack
  }

  return (
    <DropdownButton
      tooltip="Align objects"
      renderPopup={() => (
        <div className={cn(toolbar_styles.miniToolbarLayout, toolbar_styles.withSeparators)}>
          <ButtonGroup>
            <Button onClick={onAlign} data-align="left" tooltip="Align left">
              <Icon icon="icon-align-left" />
            </Button>
            <Button onClick={onAlign} data-align="hcenter" tooltip="Align horizontal centers">
              <Icon icon="icon-align-vcenter" />
            </Button>
            <Button onClick={onAlign} data-align="right" tooltip="Align right">
              <Icon icon="icon-align-right" />
            </Button>
          </ButtonGroup>

          <ButtonGroup>
            <Button onClick={onAlign} data-align="top" tooltip="Align top">
              <Icon icon="icon-align-top" />
            </Button>
            <Button onClick={onAlign} data-align="vcenter" tooltip="Align vertical centers">
              <Icon icon="icon-align-hcenter" />
            </Button>
            <Button onClick={onAlign} data-align="bottom" tooltip="Align bottom">
              <Icon icon="icon-align-bottom" />
            </Button>
          </ButtonGroup>

          <ButtonGroup>
            <Button onClick={onDistributeH} tooltip="Distribute horizontally">
              <Icon icon="icon-align-dist-horizontal" />
            </Button>
            <Button onClick={onDistributeV} tooltip="Distribute vertically">
              <Icon icon="icon-align-dist-vertical" />
            </Button>
          </ButtonGroup>
        </div>
      )}
      arrowSize={12}
      className={toolbar_styles.miniToolbarPopup}
    >
      <Icon icon="icon-align-vcenter" />
    </DropdownButton>
  );
}
